import { H2, LoadingIndicator } from '@triumph/design-system';
import { Route, Routes } from 'react-router-dom';

import { CenteredContainer } from './PageRouter.StyledComponents';

import { Applicant } from '../pages/Applicant';
import { ApplicantsQueue } from '../pages/ApplicantsQueue';
import { EmailTemplatePreviewPage } from '../pages/EmailTemplatePreview';
import { HangfireDashboard } from '../pages/HangfireDashboard';
import { ManageTemplates } from '../pages/ManageTemplates';
import { RecentNeedsMoreInfo } from '../pages/RecentNeedsMoreInfo';
import { Home } from '../pages/Home';
import { LoginCallback } from '../pages/LoginCallback';
import { LoginError } from '../pages/LoginError';
import { ApplicantContextProvider } from '../providers/ApplicantContextProvider';
import { usePermissions } from '../providers/PermissionsContextProvider';
import { Layout } from '../shared/components/Layout';
import { Feature } from '../shared/constants/features';
import { useFeatureFlags } from '../shared/constants/featureFlags';
import { PageRoutes } from '../shared/routes';

const ProtectedApplicant = () => {
    const { hasFeature, isLoading, isServerOutage } = usePermissions();

    if (isLoading) {
        return (
            <CenteredContainer>
                <LoadingIndicator show />
            </CenteredContainer>
        );
    }

    if (hasFeature(Feature.ViewApplicant)) {
        return <Applicant />;
    }

    if (isServerOutage) {
        return (
            <CenteredContainer>
                <H2>We can't reach the server right now. Please refresh to try again.</H2>
            </CenteredContainer>
        );
    }

    return (
        <CenteredContainer>
            <H2>You don't have access to this page</H2>
        </CenteredContainer>
    );
};

const ProtectedManageTemplates = () => {
    const { isManageTemplatesEnabled } = useFeatureFlags();

    if (isManageTemplatesEnabled) {
        return <ManageTemplates />;
    }

    return (
        <CenteredContainer>
            <H2>This feature isn't available yet</H2>
        </CenteredContainer>
    );
};

const PageRouterInternal = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path={PageRoutes.HOME} element={<Home />} />
                <Route path={PageRoutes.RECENT_NEEDS_MORE_INFO} element={<RecentNeedsMoreInfo />} />
                <Route path={PageRoutes.MANAGE_TEMPLATES} element={<ProtectedManageTemplates />} />
                <Route path={PageRoutes.HANGFIRE_DASHBOARD} element={<HangfireDashboard />} />
                <Route path={PageRoutes.EMAIL_TEMPLATE_PREVIEW} element={<EmailTemplatePreviewPage />} />

                <Route path={PageRoutes.AUTH_ERROR} element={<LoginError />} />
                <Route path={PageRoutes.LOGIN_CALLBACK} element={<LoginCallback />} />
            </Route>

            <Route
                element={
                    <ApplicantContextProvider>
                        <Layout />
                    </ApplicantContextProvider>
                }
            >
                <Route path={PageRoutes.APPLICANT} element={<ProtectedApplicant />} />
                <Route path={PageRoutes.APPLICANTS} element={<ApplicantsQueue />} />
            </Route>
        </Routes>
    );
};

export { PageRouterInternal as PageRouter };
